import { getInteractor } from "services/local.service";

import { SystemConstant } from "const";
import { toSnake } from "utils";
import { normalizeError } from "utils/string.utils";

class SenderKeyMessage {
  senderMessageProcess = async (newMessage, messageOptions, prefixKey, encryptTypeProtocol) => {
    try {
      await getInteractor(prefixKey).LocalCryptoService.storeDistributionKey(
        newMessage.senderId,
        newMessage.senderDeviceId,
        newMessage.groupId,
        newMessage.content,
        encryptTypeProtocol,
        messageOptions.index_send_number,
      );
    } catch (error) {
      let errorObj = error;
      // Nếu error.message chứa JSON, parse ra object
      if (typeof error.message === "string") {
        const match = error.message.match(/\{.*\}$/);
        if (match) {
          try {
            errorObj = JSON.parse(match[0]);
          } catch (e) {
            // Không parse được thì giữ nguyên errorObj
          }
        }
      }
      await getInteractor(prefixKey).LocalMessageService.saveFromRemote([toSnake(newMessage)]);
      if (errorObj.name === "DuplicatedMessage") {
        return {
          type: SystemConstant.ENCRYPT_STATUS_TYPE.success,
          code: SystemConstant.ENCRYPT_STATUS_CODE.successDuplicateSenderKey01,
          message: normalizeError(error),
        };
      }
      return {
        type: SystemConstant.ENCRYPT_STATUS_TYPE.error,
        code: SystemConstant.ENCRYPT_STATUS_CODE.errorSenderKeySignalError,
        message: normalizeError(error),
      };
    }

    await getInteractor(prefixKey).LocalCryptoService.updateSenderKey(
      { waiting_index: -1 },
      newMessage.senderId,
      newMessage.senderDeviceId,
      newMessage.groupId,
      encryptTypeProtocol,
    );

    await getInteractor(prefixKey).LocalMessageService.saveFromRemote([toSnake(newMessage)]);
    return {
      type: SystemConstant.ENCRYPT_STATUS_TYPE.success,
      code: SystemConstant.ENCRYPT_STATUS_CODE.successSenderKey,
    };
  };
}

export default SenderKeyMessage;
